import React, { useState, useEffect } from "react";
import "./admincontrols.css";

const MilestoneManager = () => {
  const [formMode, setFormMode] = useState(null); 
  const [year, setYear] = useState("");
  const [content, setContent] = useState("");
  const [image, setImage] = useState(null);
  const [message, setMessage] = useState("");
  const [config, setConfig] = useState(null);

  // Load config.json
  useEffect(() => {
    fetch("/config.json")
      .then(res => res.json())
      .then(data => setConfig(data))
      .catch(err => console.error("Failed to load config.json:", err));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!config) return;

    const formData = new FormData();
    formData.append("year", year);
    formData.append("content", content);
    if (image) {
      formData.append("image", image);
    }

    try {
      const response = await fetch(
        formMode === "add"
          ? `${config.BASE_URL}${config.ADD_MILESTONE}`
          : `${config.BASE_URL}${config.UPDATE_MILESTONE}`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();
      if (result.success) {
        setMessage(result.message);
      } else {
        setMessage(result.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Error submitting milestone:", error);
      setMessage("Server error, please try again later.");
    }

    // reset after submit
    setYear("");
    setContent("");
    setImage(null);
    setFormMode(null);
  };

  return (
    <div className="milestone-container">
      {/* Action buttons */}
      <div className="button-group">
        <button onClick={() => setFormMode("add")} className="btn add-btn">
          Add Milestone
        </button>
        <button onClick={() => setFormMode("update")} className="btn update-btn">
          Update Milestone
        </button>
      </div>

      {/* Conditional Form */}
      {formMode && (
        <form className="milestone-form" onSubmit={handleSubmit}>
          <h2>{formMode === "add" ? "Add Milestone" : "Update Milestone"}</h2>

          <label>Year:</label>
          <input
            type="text"
            value={year}
            onChange={(e) => setYear(e.target.value)}
            placeholder="Enter year"
            required
          />

          <label>Content:</label>
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="Enter milestone content"
            rows="4"
            required
          />

          <label>Image:</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setImage(e.target.files[0])}
          />

          <button type="submit" className="btn submit-btn">
            {formMode === "add" ? "Save Milestone" : "Update Milestone"}
          </button>
        </form>
      )}

      {/* Status message */}
      {message && <p className="status-message">{message}</p>}
    </div>
  );
};

export default MilestoneManager;
